<template>
  <section class="mc-onboarding">
    <div class="container-xxl mc-onboarding-wrapper">
      <div class="d-flex justify-content-center">
        <div class="mc-onboarding-images">
          <figure>
            <img src="@/assets/images/onboarding/laptop.png" alt="" title="" />
          </figure>
        </div>
        <div class="mc-onboarding-content">
          <h1 class="mc-onboarding-logo">
            <img ref="imgPrimaryLogo" :src="getAsset('primaryLogo', 'login')" alt />
          </h1>
          <section
            v-if="currentStep === 1"
            id="onboarding-one"
            class="mc-onboarding-content__wrapper mc-onboarding-content__wrapper-step1"
          >
            <a @click="backtoDashboard"><i class="mc-fa icon-fill_arrow-left me-1"></i> Lewati</a>
            <h3 class="mc-onboarding-content__label my-4">
              Persiapkan operasional perusahaan Anda dengan memilih rekomendasi notifikasi
              berdasarkan industri berikut
            </h3>
            <div class="mc-onboarding-content__list">
              <div class="mc-onboarding-content__list-wrapper">
                <div>
                  <div
                    v-for="industry in industries"
                    :key="industry.templateId"
                    class="mc-onboarding-content__item"
                    @click="nextStep(industry)"
                  >
                    <img
                      :src="industry.iconUrl || getDefaultIconForCategory(industry.nameIdn)"
                      :alt="language === 'id' ? industry.nameIdn : industry.nameEng"
                      :title="language === 'id' ? industry.nameIdn : industry.nameEng"
                    />
                    <span>{{ language === 'id' ? industry.nameIdn : industry.nameEng }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            v-if="currentStep === 2"
            id="onboarding-two"
            class="mc-onboarding-content__wrapper mc-onboarding-content__wrapper-step2"
          >
            <a @click.prevent="prevStep"><i class="mc-fa icon-fill_arrow-left me-1"></i> Kembali</a>
            <div v-if="isLoading" class="mc-onboarding-content__loading">
              <b-spinner small />
            </div>
            <div v-else class="mc-onboarding-content__notification">
              <div class="mc-onboarding-content__notification-icon">
                <img
                  :src="
                    selectedIndustry?.iconUrl ||
                    getDefaultIconForCategory(selectedIndustry?.nameIdn)
                  "
                  :alt="language === 'id' ? selectedIndustry?.nameIdn : selectedIndustry?.nameEng"
                  :title="language === 'id' ? selectedIndustry?.nameIdn : selectedIndustry?.nameEng"
                />
                <div>
                  <span>{{
                    language === 'id' ? selectedIndustry?.nameIdn : selectedIndustry?.nameEng
                  }}</span>
                  <p class="mt-2 mb-0">
                    {{
                      language === 'id'
                        ? selectedIndustry?.descriptionIdn
                        : selectedIndustry?.descriptionEng
                    }}
                  </p>
                </div>
              </div>
              <div class="mc-onboarding-content__notification-wrapper">
                <p>Kami menyarankan Anda untuk mengaktifkan notifikasi berikut</p>
                <div class="mc-onboarding-content__notification-list-wrapper">
                  <div class="mc-onboarding-content__notification-list">
                    <div
                      class="mc-onboarding-content__notification-item"
                      v-for="(item, index) in defaultNotificationItems"
                      :key="index"
                    >
                      <div class="mc-onboarding-content__notification-item-header">
                        <label><McCheckbox v-model="item.checked" /> {{ item.title }}</label>
                        <span @click="toggleDescription(index, 'default')">
                          Deskripsi
                          <i
                            class="mc-fa"
                            :class="
                              item.isOpen ? 'icon-fill_arrow-ios-up' : 'icon-fill_arrow-ios-down'
                            "
                          ></i>
                        </span>
                      </div>
                      <div
                        class="mc-onboarding-content__notification-item-content"
                        v-show="item.isOpen"
                      >
                        {{ item.description }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="additionalNotificationItems.length > 0"
                    class="mc-onboarding-content__notification-item-more"
                    @click="toggleShowAllItems"
                  >
                    {{ showAdditionalItems ? 'Tutup' : 'Lihat Lainnya' }}
                    <i
                      class="mc-fa"
                      :class="
                        showAdditionalItems ? 'icon-fill_arrow-ios-up' : 'icon-fill_arrow-ios-down'
                      "
                    ></i>
                  </div>
                  <div
                    v-show="showAdditionalItems"
                    class="mt-2 mc-onboarding-content__notification-list mc-onboarding-content__notification-list--additional"
                  >
                    <div
                      v-for="(item, index) in additionalNotificationItems"
                      :key="index"
                      class="mc-onboarding-content__notification-item"
                    >
                      <div class="mc-onboarding-content__notification-item-header">
                        <label><McCheckbox v-model="item.checked" /> {{ item.title }}</label>
                        <span @click="toggleDescription(index, 'additional')">
                          Deskripsi
                          <i
                            class="mc-fa"
                            :class="
                              item.isOpen ? 'icon-fill_arrow-ios-up' : 'icon-fill_arrow-ios-down'
                            "
                          ></i>
                        </span>
                      </div>
                      <div
                        v-show="item.isOpen"
                        class="mc-onboarding-content__notification-item-content"
                      >
                        {{ item.description }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mc-onboarding-content__notification-end">
                <p>
                  Otomatis diterapkan untuk seluruh kendaraan.
                  <a class="primary-500" href="https://kb.mceasy.com/docs/" target="_blank">
                    Pelajari lebih lanjut
                  </a>
                </p>
                <div class="d-flex align-items-center">
                  <McButton
                    text="Aktifkan"
                    variant="primary"
                    :disabled="!hasCheckedNotification || isLoading"
                    @click="activateNotification"
                  />
                </div>
              </div>
            </div>
          </section>
          <section
            v-if="currentStep === 3"
            id="onboarding-three"
            class="mc-onboarding-content__wrapper mc-onboarding-content__wrapper-step3"
          >
            <div class="mc-onboarding-content__success">
              <div class="mc-onboarding-content__success-text">
                <figure>
                  <img src="@/assets/images/onboarding/bell-check.jpg" alt="" title="" />
                </figure>
                <div v-if="hasAccess(['e4a-alert-center-main:read'])">
                  <h3>Berhasil Mengaktifkan Notifikasi</h3>
                  <p>
                    Anda dapat mengatur kembali notifikasi ini pada menu
                    <i>Notifikasi > Pengaturan</i>
                  </p>
                </div>
                <div v-else>
                  <h3>Berhasil Mengirim Permintaan</h3>
                  <p>Permintaan Anda akan kami proses. Maksimal 3x24 jam</p>
                </div>
                <McButton
                  variant="outline-primary"
                  text="Lihat kembali notifikasi yang sudah diatur"
                  :icon="arrowRight"
                  icon-position="right"
                  @click="notifPreview()"
                />
              </div>
              <div class="mc-onboarding-content__success-notification">
                <p>Aktifkan juga notifikasi berdasarkan <i>add-on</i> yang Anda gunakan</p>
                <div>
                  <div
                    v-for="template in addOnTemplates"
                    :key="template.templateId"
                    class="mc-onboarding-content__success-notification-item"
                  >
                    <span>{{ language === 'id' ? template.nameIdn : template.nameEng }}</span>
                    <div>
                      <div
                        v-for="alert in template.defaultAlertCodes"
                        :key="alert.alertCode"
                        class="mc-onboarding-content__success-notification-item-type"
                      >
                        <label>
                          <McCheckbox v-model="addOnAlertStatus[alert.alertCode]" />
                          {{ language === 'id' ? alert.descriptionIdn : alert.descriptionEng }}
                          <i
                            :id="`tooltip-info-${alert.alertCode}`"
                            class="mc-fa icon-outline_info ms-1"
                          ></i>
                        </label>
                        <b-tooltip
                          :target="`tooltip-info-${alert.alertCode}`"
                          triggers="hover"
                          placement="topLeft"
                        >
                          {{
                            language === 'id' ? alert.fullDescriptionIdn : alert.fullDescriptionEng
                          }}
                        </b-tooltip>
                      </div>
                      <div
                        v-for="alert in template.additionalAlertCodes"
                        :key="`add-${alert.alertCode}`"
                        class="mc-onboarding-content__success-notification-item-type"
                      >
                        <label>
                          <McCheckbox v-model="addOnAlertStatus[alert.alertCode]" />
                          {{ language === 'id' ? alert.descriptionIdn : alert.descriptionEng }}
                          <i
                            :id="`tooltip-info-add-${alert.alertCode}`"
                            class="mc-fa icon-outline_info ms-1"
                          ></i>
                        </label>
                        <b-tooltip
                          :target="`tooltip-info-add-${alert.alertCode}`"
                          triggers="hover"
                          placement="topLeft"
                        >
                          {{
                            language === 'id' ? alert.fullDescriptionIdn : alert.fullDescriptionEng
                          }}
                        </b-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-end">
                  <McButton variant="primary" text="Selesai" @click="doneOnboarding" />
                </div>
              </div>
            </div>
          </section>
          <section
            v-if="currentStep === 4"
            id="onboarding-four"
            class="mc-onboarding-content__wrapper mc-onboarding-content__wrapper-step4"
          >
            <a @click.prevent="prevStep"><i class="mc-fa icon-fill_arrow-left me-1"></i> Kembali</a>
            <h3 class="mc-onboarding-content__label my-4">Notifikasi yang sudah diaktifkan</h3>
            <div class="mc-onboarding-content__notification-active">
              <div
                v-for="(notifications, category) in groupedActivatedNotifications"
                :key="category"
                class="mc-onboarding-content__notification-active-item"
              >
                <h4>{{ category }}</h4>
                <div>
                  <p v-for="notification in notifications" :key="notification.alertCode">
                    {{ notification.title }}
                  </p>
                </div>
              </div>
            </div>
            <p class="text-muted">
              Anda dapat mengatur kembali notifikasi ini pada manu Notifikasi > Pengaturan
            </p>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import i18n from '../../../i18n'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import appConfig from '@/app.config'
import McButton from '@/components/McButton'
import {
  GET_NOTIFICATION_TEMPLATES,
  CREATE_BULK_NOTIFICATION_RULES,
} from '@/services/api/setting/notification/List.js'
import { UPDATE_COMPANY } from '@/services/api/setting/development/index.js'
import McCheckbox from '@/components/McCheckbox'

export default {
  page: {
    title: 'Onboarding',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    McButton,
    McCheckbox,
  },
  mixins: [Helper, MixPanel],
  props: {
    arrowRight: {
      type: String,
      default: 'icon-outline_arrow-circle-right',
    },
  },
  data() {
    return {
      language: i18n.locale,
      currentStep: 1,
      totalSteps: 4,
      showAdditionalItems: false,
      isLoading: false,
      defaultNotificationItems: [],
      additionalNotificationItems: [],
      industries: [],
      loading: false,
      selectedIndustry: null,
      activatedNotifications: [],
      addOnTemplates: [],
      addOnAlertStatus: {},
      groupedActivatedNotifications: {},
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getAsset: 'asset/getAsset',
    }),

    hasCheckedNotification() {
      return this.defaultNotificationItems.some((item) => item.checked)
    },
  },
  created() {
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', i18n.locale)
    }
    i18n.locale = localStorage.getItem('language')
    this.language = localStorage.getItem('language')

    this.fetchIndustries()
    this.fetchAddOnTemplates()
  },
  methods: {
    setLanguage(language) {
      this.language = language
      i18n.locale = language
      localStorage.setItem('language', i18n.locale)
      localStorage.removeItem('dashboard-config')
      localStorage.removeItem('notification-popup')
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },

    async fetchIndustries() {
      this.loading = true
      try {
        const response = await this.$apollo.query({
          query: GET_NOTIFICATION_TEMPLATES,
          variables: {
            filter: {
              category: 'Onboarding',
            },
          },
        })

        if (response.data.alertRuleTemplates.isSuccessful) {
          this.industries = response.data.alertRuleTemplates.alertRuleTemplates.data
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching industries:', error)
      } finally {
        this.loading = false
      }
    },

    async fetchAddOnTemplates() {
      try {
        const response = await this.$apollo.query({
          query: GET_NOTIFICATION_TEMPLATES,
          variables: {
            filter: {
              category: 'AddOn',
            },
          },
        })

        if (response.data.alertRuleTemplates.isSuccessful) {
          this.addOnTemplates = response.data.alertRuleTemplates.alertRuleTemplates.data
          this.addOnTemplates.forEach((template) => {
            template.defaultAlertCodes.forEach((alert) => {
              this.$set(this.addOnAlertStatus, alert.alertCode, false)
            })
            template.additionalAlertCodes.forEach((alert) => {
              this.$set(this.addOnAlertStatus, alert.alertCode, false)
            })
          })
        }
      } catch (error) {
        console.error('Error fetching add-on templates:', error)
      }
    },

    async backtoDashboard() {
      const updateResponse = await this.$apollo.mutate({
        mutation: UPDATE_COMPANY,
        variables: {
          input: {
            id: this.getCompanyId(),
            onboardingNotif: false,
          },
        },
      })
      if (!updateResponse.data.updateCompany.isSuccessful) {
        this.$mcToast.error(updateResponse.data.updateCompany.message)
        return
      }
      const url = `${window.location.protocol}//${window.location.host}/dashboard/`
      setTimeout(() => {
        window.location.href = url
      }, 500)
    },

    nextStep(industry) {
      this.selectedIndustry = industry

      if (industry && industry.templateId) {
        this.defaultNotificationItems = industry.defaultAlertCodes.map((alert) => ({
          title: this.language === 'id' ? alert.descriptionIdn : alert.descriptionEng,
          description: this.language === 'id' ? alert.fullDescriptionIdn : alert.fullDescriptionEng,
          checked: true,
          isOpen: false,
          alertCode: alert.alertCode,
        }))

        this.additionalNotificationItems = industry.additionalAlertCodes.map((alert) => ({
          title: this.language === 'id' ? alert.descriptionIdn : alert.descriptionEng,
          description: this.language === 'id' ? alert.fullDescriptionIdn : alert.fullDescriptionEng,
          checked: false,
          isOpen: false,
          alertCode: alert.alertCode,
        }))
      }

      if (this.currentStep < this.totalSteps) {
        this.currentStep++
      }
    },

    async activateNotification() {
      this.isLoading = true
      try {
        const selectedDefaultAlerts = this.defaultNotificationItems
          .filter((item) => item.checked)
          .map((item) => item.alertCode)

        const selectedAdditionalAlerts = this.additionalNotificationItems
          .filter((item) => item.checked)
          .map((item) => item.alertCode)

        const allSelectedAlerts = [...selectedDefaultAlerts, ...selectedAdditionalAlerts]

        const response = await this.$apollo.mutate({
          mutation: CREATE_BULK_NOTIFICATION_RULES,
          variables: {
            input: {
              templates: [
                {
                  templateId: this.selectedIndustry.templateId,
                  alertCodes: allSelectedAlerts,
                },
              ],
            },
          },
        })

        if (response.data.createAlertRules.isSuccessful) {
          this.activatedNotifications = response.data.createAlertRules.createAlertRules.data
          const companyId = this.getCompanyId()
          this.track('Click Terapkan on Notification Onboarding (Web)', { userType: 'New User' })
          if (companyId) {
            const updateCompanyResponse = await this.$apollo.mutate({
              mutation: UPDATE_COMPANY,
              variables: {
                input: {
                  id: companyId,
                  setupNotifCompleted: true,
                },
              },
            })

            if (!updateCompanyResponse.data.updateCompany.isSuccessful) {
              console.error(
                'Failed to update company setupNotifCompleted:',
                updateCompanyResponse.data.updateCompany.message
              )
            }
          }
          await this.fetchAddOnTemplates()

          this.currentStep = 3
        } else {
          this.$bvToast.toast(response.data.createAlertRules.message, {
            title: 'Error',
            variant: 'danger',
          })
        }
      } catch (error) {
        console.error('Error activating notifications:', error)
        this.$bvToast.toast('Terjadi kesalahan saat mengaktifkan notifikasi', {
          title: 'Error',
          variant: 'danger',
        })
      } finally {
        this.isLoading = false
      }
    },

    async notifPreview() {
      try {
        const response = await this.$apollo.query({
          query: GET_NOTIFICATION_TEMPLATES,
          variables: {
            filter: {
              category: 'Onboarding',
            },
          },
        })

        if (response.data.alertRuleTemplates.isSuccessful) {
          const selectedTemplate = response.data.alertRuleTemplates.alertRuleTemplates.data.find(
            (template) => template.templateId === this.selectedIndustry.templateId
          )

          if (selectedTemplate) {
            this.groupedActivatedNotifications = {
              [this.language === 'id' ? selectedTemplate.nameIdn : selectedTemplate.nameEng]: [],
            }

            const selectedAlertCodes = [
              ...this.defaultNotificationItems
                .filter((item) => item.checked)
                .map((item) => item.alertCode),
              ...this.additionalNotificationItems
                .filter((item) => item.checked)
                .map((item) => item.alertCode),
            ]

            selectedTemplate.defaultAlertCodes.forEach((alert) => {
              if (selectedAlertCodes.includes(alert.alertCode)) {
                this.groupedActivatedNotifications[
                  this.language === 'id' ? selectedTemplate.nameIdn : selectedTemplate.nameEng
                ].push({
                  title: this.language === 'id' ? alert.descriptionIdn : alert.descriptionEng,
                  alertCode: alert.alertCode,
                })
              }
            })

            selectedTemplate.additionalAlertCodes.forEach((alert) => {
              if (selectedAlertCodes.includes(alert.alertCode)) {
                this.groupedActivatedNotifications[
                  this.language === 'id' ? selectedTemplate.nameIdn : selectedTemplate.nameEng
                ].push({
                  title: this.language === 'id' ? alert.descriptionIdn : alert.descriptionEng,
                  alertCode: alert.alertCode,
                })
              }
            })
          }
        }
        this.currentStep = 4
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching notification templates:', error)
        this.prepareActivatedNotificationsPreview()
        this.currentStep = 4
      }
    },

    prepareActivatedNotificationsPreview() {
      const industryName =
        this.language === 'id' ? this.selectedIndustry.nameIdn : this.selectedIndustry.nameEng
      this.groupedActivatedNotifications = {
        [industryName]: [],
      }

      const selectedDefaultItems = this.defaultNotificationItems.filter((item) => item.checked)
      const selectedAdditionalItems = this.additionalNotificationItems.filter(
        (item) => item.checked
      )

      selectedDefaultItems.forEach((item) => {
        this.groupedActivatedNotifications[industryName].push({
          title: item.title,
          alertCode: item.alertCode,
        })
      })

      selectedAdditionalItems.forEach((item) => {
        this.groupedActivatedNotifications[industryName].push({
          title: item.title,
          alertCode: item.alertCode,
        })
      })
    },

    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    },

    async doneOnboarding() {
      this.isLoading = true
      try {
        const selectedTemplates = []

        this.addOnTemplates.forEach((template) => {
          const alertCodesForTemplate = []
          template.defaultAlertCodes.forEach((alert) => {
            if (this.addOnAlertStatus[alert.alertCode]) {
              alertCodesForTemplate.push(alert.alertCode)
            }
          })
          template.additionalAlertCodes.forEach((alert) => {
            if (this.addOnAlertStatus[alert.alertCode]) {
              alertCodesForTemplate.push(alert.alertCode)
            }
          })
          if (alertCodesForTemplate.length > 0) {
            selectedTemplates.push({
              templateId: template.templateId,
              alertCodes: alertCodesForTemplate,
            })
          }
        })
        if (selectedTemplates.length > 0) {
          const response = await this.$apollo.mutate({
            mutation: CREATE_BULK_NOTIFICATION_RULES,
            variables: {
              input: {
                templates: selectedTemplates,
              },
            },
          })

          if (response.data.createAlertRules.isSuccessful) {
            this.$bvToast.toast('Notifikasi berhasil diaktifkan', {
              title: 'Sukses',
              variant: 'success',
            })
          } else {
            this.$bvToast.toast(response.data.createAlertRules.message, {
              title: 'Error',
              variant: 'danger',
            })
          }
        }
        const url = `${window.location.protocol}//${window.location.host}/dashboard/`
        setTimeout(() => {
          window.location.href = url
        }, 500)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error activating add-on notifications:', error)
        this.$bvToast.toast('Terjadi kesalahan saat mengaktifkan notifikasi', {
          title: 'Error',
          variant: 'danger',
        })
      } finally {
        this.isLoading = false
      }
    },

    getDefaultIconForCategory(categoryName) {
      const iconMap = {
        Otobus: require('@/assets/images/onboarding/icon/Otobus.png'),
        Distribusi: require('@/assets/images/onboarding/icon/Distribution.png'),
        Manufaktur: require('@/assets/images/onboarding/icon/Manufactur.png'),
        'Rantai Pendingin': require('@/assets/images/onboarding/icon/Cold-chain.png'),
        Agrikultur: require('@/assets/images/onboarding/icon/Agriculture.png'),
        Tambang: require('@/assets/images/onboarding/icon/Mining.png'),
        Rental: require('@/assets/images/onboarding/icon/Rental.png'),
        Transportasi: require('@/assets/images/onboarding/icon/Transportation.png'),
        'Notifikasi Umum': require('@/assets/images/onboarding/icon/General.png'),
        Logistic: require('@/assets/images/onboarding/icon/Logistic.png'),
      }

      return iconMap[categoryName] || require('@/assets/images/onboarding/icon/etc.png')
    },

    toggleDescription(index, type = 'default') {
      if (type === 'default') {
        this.defaultNotificationItems[index].isOpen = !this.defaultNotificationItems[index].isOpen
      } else if (type === 'additional') {
        this.additionalNotificationItems[index].isOpen =
          !this.additionalNotificationItems[index].isOpen
      }
    },

    toggleShowAllItems() {
      this.showAdditionalItems = !this.showAdditionalItems
    },
  },
}
</script>
